export default __webpack_public_path__ + "static/media/onboardingAsideBg.207040d3.png";